var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.83,20l8.58-8.59a2,2,0,0,0-2.82-2.82L20,17.17,11.41,8.59a2,2,0,0,0-2.82,2.82L17.17,20,8.59,28.59a2,2,0,1,0,2.82,2.82L20,22.83l8.59,8.58a2,2,0,0,0,2.82-2.82Z","transform":"translate(-8 -8)"}));
}

Exit.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Exit;

Exit.default = Exit;
